import { render, staticRenderFns } from "./FilterSummaryItemGroup.vue?vue&type=template&id=2e28447f&"
import script from "./FilterSummaryItemGroup.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryItemGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports